import { render, staticRenderFns } from "./build10.vue?vue&type=template&id=7bfad05e&scoped=true&"
import script from "./build10.vue?vue&type=script&lang=js&"
export * from "./build10.vue?vue&type=script&lang=js&"
import style0 from "./build10.vue?vue&type=style&index=0&id=7bfad05e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfad05e",
  null
  
)

export default component.exports